// import { Helmet, style } from "../Helmet";

import { Colors, Metrics, Typography } from "../../resources";

import React from "react";
import { StyleSheet } from "react-native";
import Tippy from "@tippy.js/react";

interface IProps {
  children: JSX.Element;
  placement?: any;
  content: string | JSX.Element;
  disabled?: boolean;
}

const STooltipBase: React.FC<IProps> = ({
  placement = "bottom",
  children,
  content,
  disabled,
}) => {
  return (
    <>
      {disabled ? (
        <span>{children}</span>
      ) : (
        <Tippy
          content={content}
          theme="dark"
          arrow={false}
          placement={placement}
          duration={50}
        >
          <span>{children}</span>
        </Tippy>
      )}
    </>
  );
};
const styles = StyleSheet.create({
  title: {
    ...Typography.body1Medium,
    textAlign: "left",
    color: Colors.white,
    marginBottom: Metrics.padding8,
  },
  content: {
    ...Typography.body1,
    textAlign: "left",
    color: Colors.white,
    lineHeight: 14.4,
  },
});

export default STooltipBase;
